'use strict';
var canUseDOM = require('../util/inDOM');
var on = function on() {};

if (canUseDOM) {
  on = (function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, handler);
    };
  })();
}

module.exports = on;


//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-router-scroll/~/scroll-behavior/~/dom-helpers/events/on.js
// module id = 239
// module chunks = 0